module.exports = __webpack_public_path__ + "prod/20260813181040/img/service.edbff227.png";